import { Link, Stack, Typography, useTheme } from '@mui/material';

import { Strings } from '@app/constants';
import { AuthLayout } from '@app/layouts';
import { SetPasswordForm } from './set-password-form';

// ------------------------------------------------

const SetPasswordPage = () => {
  const theme=useTheme();
  return (
    <AuthLayout title={Strings.header.setPassword}>
      <Stack spacing={2}>
        <Typography variant="h3">{Strings.auth.resetPassword}</Typography>
        <Typography variant="body1" color={theme.palette.grey[600]}>
          {Strings.auth.YourNewPassword}
        </Typography>
        <SetPasswordForm />
      </Stack>
    </AuthLayout>
  );
};

export { SetPasswordPage };
